import { Component, OnInit, OnDestroy, Inject, ViewChild, ChangeDetectorRef, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { ARService } from '../../ar.service';
import { ArCardPaymentComponent } from '../ar-card-payment/ar-card-payment.component';
import { ArPaymentInvoiceGeneratorComponent } from '../ar-payment-invoice-generator/ar-payment-invoice-generator.component';
import { dataARLedger, dataContact, dataPatient, enumValidValueItem } from '../../_models/ar.models';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableFooterDataModel } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { DataARLedgerListModel, isPayableLedgerItem } from '../../models/data-ar-ledger-list.model';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { Globals } from '../../../../globals';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { MessagingService } from '../../../../services/messaging.service';
import { ArPaymentCancelComponent } from '../ar-payment-cancel/ar-payment-cancel.component';
import { SavePaymentDistributionsModel } from '../../models/save-payment-distributions.model';
import { PaymentProcessorConfigurationService } from '../../../configuration/payment-processor-configuration/payment-processor-configuration..service';
import { PaymentProcessorDeviceListModel } from '../../../configuration/models/payment-processor-device-list.model';
import { CfgARPaymentProcessorModel } from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { CreateLedgerItemForPaymentModel } from '../../models/create-ledger-item-for-payment.model';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { DataARPaymentDistribsModel } from '../../../../models/accountsReceivable/data-ar-payment-distribs.model';
import { CfgARPaymentMethodModel } from '../../../../models/accountsReceivable/cfg-ar-payment-method';
import { PaymentMethodConfigurationService } from '../../../configuration/payment-method-configuration/payment-method-configuration.service';
import { ArLedgerItemSelectComponent } from '../../ledger/ar-ledger-item-select/ar-ledger-item-select.component';
import { ConfirmComponent } from '../../../../dialog/confirm-dialog/confirm.component';
import { PaymentAmountForDoctorModel } from '../../models/payment-amount-for-doctor.model';
import { DataArPaymentToken } from '../../../../models/accountsReceivable/data-ar-cc-payment-token';
import { ITDOPaymentTransactionResult } from '@tdo-inc/tdo-payment';
import { ArPaymentTokenConsentComponent } from '../ar-payment-token-consent/ar-payment-token-consent.component';
import { CreditCardTokenPaymentResponse } from '../../../../models/accountsReceivable/credit-card-token-payment-response';
import { PrintCCReceiptModel } from 'src/app/models/accountsReceivable/PrintCCReceipt.model';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';
import { ReportIDEnum } from 'src/app/models/enum/report-ID-enum';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { firstValueFrom } from 'rxjs';
import { UiService } from 'src/app/services/ui.service';


@Component({
    standalone: false,
    selector: 'app-ar-payment',
    templateUrl: './ar-payment.component.html',
    styleUrls: ['./ar-payment.component.scss']
})
export class ArPaymentComponent implements OnInit, OnDestroy {

    private destroyed = false;
    @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
    searchPredicate: (data: any, filter: string) => boolean;
    footerData: TdoTableFooterDataModel[] = [];

    messagingSubscription: any;
    applyPayment: boolean = false;
    hideNoBalanceItems: boolean = false;
    type: string;
    dataContact: dataContact;
    dataPatient: dataPatient;
    dataLedgerItems: DataARLedgerListModel[] = [];
    dataCreditLedgerItems: DataARLedgerListModel[] = [];

    arAccounts: CfgARAccountModel[] = [];
    arAccountsAll: CfgARAccountModel[] = [];
    paymentMethods: CfgARPaymentMethodModel[] = [];
    paymentCCSources: enumValidValueItem[] = [];
    paymentESources: enumValidValueItem[] = [];
    paymentESourcesMaster: enumValidValueItem[] = [];
    paymentTypes: enumValidValueItem[] = [];
    contactList: dataContact[] = [];
    ledgerItems: dataARLedger[] = [];
    isLoading: boolean = false;
    isPaymentProcessing = signal(false);
    paymentDevices: PaymentProcessorDeviceListModel[] = [];
    paymentProcessors: CfgARPaymentProcessorModel[] = [];
    paymentTokens: DataArPaymentToken[] = [];
    isOpeningCardConsent: boolean = false;
    selectedToken: DataArPaymentToken;
    initializeToken: boolean = false;
    saveCCInfo: number = 0;
    verbalConsentInfo: string;
    selectedDoctorARLocId: string;

    DocPaymentProcessors: CfgARPaymentProcessorModel[] = [];

    PaymentAmountForDoctors: PaymentAmountForDoctorModel[];

    paymentAmount: number = 0;
    paymentAmountNotDistributed: number = 0;
    approvedPaymentAmount: number = 0;
    selectedPaymentMethod: CfgARPaymentMethodModel;
    selectedPaymentType: enumValidValueItem;
    selectedEPaymentType: enumValidValueItem;
    selectedCCPaymentType: enumValidValueItem;
    selectedContact: dataContact;
    paymentDescription: string;
    datePostPayment: Date;
    datePaymentReceived: Date;
    dateReceivedPayment: Date;
    dateReceivedMin: Date;
    currentARPayment = signal<DataARPaymentModel | null>(null);
    currentTransactionSetupID: string;
    currentTransactionID: string;
    depositARAccountID: string;
    currentWorkStationID: string;
    creditRemainingAmount: boolean = false;
    selectedLedgerItem: DataARLedgerListModel;
    get isCreditSingleFee(): boolean {
        return !!this.selectedLedgerItem && this.dataLedgerItems.length === 1;
    }
    saveButtonCaption: string = 'Start Payment';
    currentPaymentProcessorId: string;

    enumPaymentTransactionTypeIDPurchase: string = '00000277-1000-0000-0000-000000000001';

    enumEPayTypeCredit: string = '00000082-1000-0000-0000-000000000001';
    enumLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
    enumLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
    creditRemainderOriginTypeID: string = null;
    enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
    enumPaymentSource: string = '';
    enumCurrencyUSD: string = '00000192-1000-0000-0000-000000000001';

    enumPaymentETypeCreditCard: string = '00000082-1000-0000-0000-000000000001';
    enumPaymentETypeDebitCard: string = '00000082-1000-0000-0000-000000000002';
    enumPaymentETypeCareCredit: string = '00000082-1000-0000-0000-000000000004';
    enumPaymentETypeECheck: string = '00000082-1000-0000-0000-000000000005';

    submitPaymentInSuccess = false;
    isPrintingReceipt: boolean = false;
    readonly LEDGER_ITEM_TYPE = LEDGER_ITEM_TYPE;
    readonly EnumARPaymentType = EnumARPaymentType;
    isDisabledReceivedDate: boolean;

    constructor(
        public dialogRef: MatDialogRef<ArPaymentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly arService: ARService,
        private readonly ppService: PaymentProcessorConfigurationService,
        private readonly localStorageService: LocalStorageService,
        private readonly currencyPipe: CurrencyPipe,
        private readonly dialog: MatDialog,
        private readonly globals: Globals,
        private readonly messagingService: MessagingService,
        private readonly changeDet: ChangeDetectorRef,
        private readonly paymentMethodConfigService: PaymentMethodConfigurationService,
        private readonly printService: TDOPrintService,
        private readonly uiService: UiService
    ) {
        this.searchPredicate = (ledgerData: DataARLedgerListModel, filter: string) => {
            if (ledgerData.dataARTransactionItem) {
                return ledgerData.dataARTransactionItem.Code.toLowerCase().includes(filter)
                    || ledgerData.Description.toLowerCase().includes(filter);
            }
            return ledgerData.Description.toLowerCase().includes(filter);
        };
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    ngOnInit() {

        this.isLoading = true;

        this.type = this.data.type;
        this.ledgerItems = this.data.ledgerItems;
        this.dataPatient = this.data.dataPatient;
        this.dataContact = this.data.dataContact;
        this.dataLedgerItems = this.data.dataLedgerItems;
        this.dataCreditLedgerItems = this.data.dataLedgerItems;
        this.clearSelectedItems();

        if (this.type === 'Patient') {
            this.enumPaymentSource = PAYMENT_SOURCE.Patient; // payment from patient
        } else {
            this.enumPaymentSource = PAYMENT_SOURCE.Insurance; // payment from insurance
        }

        this.datePostPayment = new Date();
        this.dateReceivedPayment = new Date();

        this.selectedContact = this.dataContact;
        this.contactList = [this.dataContact];

        this.dataPatient.dataPatientContacts.forEach(dataPatientContact => {
            if (dataPatientContact.dataContact?.FirstName !== null || dataPatientContact.dataContact?.LastName !== null) {
                this.contactList.push(dataPatientContact.dataContact);
            }
        });

        // filter ledger items to debit
        this.dataLedgerItems = this.dataLedgerItems.filter(a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding
            && this.isPayable(a) && a.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypePatient
            && a.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void
        );

        // filter ledger items where credit
        this.dataCreditLedgerItems = this.dataCreditLedgerItems.filter(
            a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding
                && (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustment
                    || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustmentInsurance
                    || a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditCreatedFromPaymentVoid)
                && a.Amount > 0);

        this.returnValidPaymentTokens();

        this.init();
    }

    createDataARPaymentRecord() {
        const promise = new Promise((resolve, reject) => {

            const createPayment = new CreatePaymentModel();
            createPayment.datePostPayment = this.datePostPayment;
            createPayment.dateReceivedPayment = this.dateReceivedPayment;
            createPayment.Description = this.paymentDescription;
            createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Patient;
            createPayment.PatientID = this.globals.currentPatientId;
            createPayment.paymentAmount = this.paymentAmount;
            createPayment.PaymentFrom = null;
            createPayment.PaymentFromContactID = this.selectedContact ? this.selectedContact.ContactId : null;
            createPayment.enumCurrencyID = this.enumCurrencyUSD;
            createPayment.DepositARAccountID = this.depositARAccountID;
            createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeIDPurchase;
            createPayment.LOCID = this.globals.LOCID;
            createPayment.PaymentProcessorID = this.currentPaymentProcessorId;

            if (this.selectedPaymentMethod) {
                createPayment.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID ? this.selectedPaymentMethod.enumARPayementCCTypeID : null;
                createPayment.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID ? this.selectedPaymentMethod.enumARPayementETypeID : null;
                createPayment.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID ? this.selectedPaymentMethod.enumARPayementTypeID : null;
            }

            // if credit payment
            if (this.selectedLedgerItem) {
                // we are assuming that this is a patient credit payment
                createPayment.enumPaymentSourceID = PAYMENT_SOURCE.ApplyCredit;
                createPayment.PaymentSourceObjectID = this.selectedLedgerItem.LedgerID;
                createPayment.enumARPayementCCTypeID = null;
                createPayment.enumARPayementETypeID = null;
                createPayment.enumARPayementTypeID = EnumARPaymentType.InternalCredit;
            }

            this.arService.createDataARPaymentRecord(createPayment)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    createLedgerItemForPayment() {
        const promise = new Promise((resolve, reject) => {

            const payload = new CreateLedgerItemForPaymentModel();
            payload.PaymentID = this.currentARPayment().PaymetnID;
            payload.enumARLedgerItemOriginTypeID = this.selectedLedgerItem?.enumARLedgerItemOriginTypeID ?? this.enumLedgerItemOriginTypePatient;
            payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPayment;
            payload.DoctorARLocId = this.selectedDoctorARLocId;
            // payload.

            // if credit is being applied
            if (this.selectedLedgerItem) {
                payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPaymentFromPatientCredit;
            }

            this.arService.createLedgerItemForPayment(payload)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    savePaymentDistributionClicked() {
        this.isPaymentProcessing.set(true);
        this.savePaymentDistribution(this.dataLedgerItems.filter(a => a.ApplyPayment > 0)).then((result: number) => {
            if (result) {
                this.createMessage('Payment distribution succeeded', 'Success');
            }
            if (this.paymentAmountNotDistributed > 0) {
                this.createCreditForUndistributedPayment();
            }
            else {
                this.close(true);
            }
        }, err => {
            this.createMessage('Problem distributing payment', 'Error');
            this.isPaymentProcessing.set(false);
        });
    }

    savePaymentDistribution(ledgerItems: DataARLedgerListModel[]) {
        const promise = new Promise((resolve, reject) => {
            const savePaymentDistributionModel = new SavePaymentDistributionsModel();
            savePaymentDistributionModel.dataARLedgerItems = ledgerItems;
            savePaymentDistributionModel.PaymentID = this.currentARPayment().PaymetnID;
            savePaymentDistributionModel.ClientPostDate = new Date();
            savePaymentDistributionModel.LOCID = parseInt(localStorage.getItem('LOCID'));

            // pass ledger item to void, if credit was used
            if (this.selectedLedgerItem) {
                savePaymentDistributionModel.LedgerItemToVoid = this.selectedLedgerItem.LedgerID; // is this right?
            }

            this.arService.savePaymentDistributions(savePaymentDistributionModel)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    autoApplyRemaining() {
        let amountRemaining = ConversionUtilities.roundDecimal(this.paymentAmountNotDistributed);
        if (amountRemaining <= 0) {
            return;
        }
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);


        this.dataLedgerItems.every(ledgerItem => {
            let amountDue = 0;
            if (this.selectedLedgerItem || ledgerItem.ARAccountID === payDr.ARAccountID)     // zoli Valpay
            {
                if (this.isPayable(ledgerItem)) {
                    const itemAmountDue = this.returnAmountDue(ledgerItem);
                    if (itemAmountDue > 0) {
                        amountDue += this.returnAmountDue(ledgerItem);

                        // try to apply payment
                        if (amountDue <= amountRemaining && amountRemaining > 0) {
                            ledgerItem.ApplyPayment = ConversionUtilities.roundDecimal(amountDue);
                            amountRemaining = ConversionUtilities.roundDecimal(amountRemaining - amountDue);
                        } else {
                            ledgerItem.ApplyPayment = ConversionUtilities.roundDecimal(amountRemaining);
                            amountRemaining = 0;
                            this.paymentAmountNotDistributed = amountRemaining;
                            return false;
                        }

                        // update remaining
                        this.paymentAmountNotDistributed = amountRemaining;
                    }
                }
            }
            return true;
        });
    }

    // charges, plus interest / late fee debit adjustments which are paid on their own row
    isPayable(ledgerItem: DataARLedgerListModel): boolean {
        return isPayableLedgerItem(ledgerItem);
    }

    returnAmountDue(ledgerItem: DataARLedgerListModel) {
        let AmountDue = 0;
        if (this.isPayable(ledgerItem) && ledgerItem.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypePatient && ledgerItem.enumARLedgerItemTypeID !== LEDGER_ITEM_STATUS.Void) {

            if (ledgerItem.AmountDuePatient) {
                AmountDue = ledgerItem.AmountDuePatient;
            }
        }

        return ConversionUtilities.roundDecimal(AmountDue);
    }

    returnAmountDueByFee(ledgerItem: DataARLedgerListModel): number {
        let AmountDue = 0;
        if (this.isPayable(ledgerItem) && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
            if (ledgerItem.AmountDue) {
                AmountDue = ledgerItem.AmountDue;
            }
        }

        return ConversionUtilities.roundDecimal(AmountDue);
    }

    returnAmountDueAllByFee(): number {
        let amountDue = 0;

        this.dataLedgerItems.forEach(ledgerItem => {
            if (this.isPayable(ledgerItem) && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
                amountDue += this.returnAmountDueByFee(ledgerItem);
            }
        });

        return ConversionUtilities.roundDecimal(amountDue);
    }

    resetApplyPaymentAmounts() {
        this.dataLedgerItems.forEach(ledgerItem => {
            if (this.isPayable(ledgerItem)) {
                ledgerItem.ApplyPayment = 0;
            }
        });
    }

    setPaymentAmountDistributionRemaining() {
        let paymentsDistributed = 0;
        this.dataLedgerItems.forEach(ledgerItem => {
            if (this.isPayable(ledgerItem)) {
                paymentsDistributed += ledgerItem.ApplyPayment;
            }
        });
       this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(this.approvedPaymentAmount - paymentsDistributed);
    }

    returnAmountDueAll() {
        let amountDue = 0;

        this.dataLedgerItems.forEach(ledgerItem => {

            if (this.isPayable(ledgerItem) && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
                amountDue += this.returnAmountDue(ledgerItem);
            }
        });

        if (this.dataLedgerItems.length > 0) {
            this.PaymentAmountForDoctors = [];
            const am = {} as PaymentAmountForDoctorModel;
            am.DoctorARLocId = this.dataLedgerItems[0].DoctorARLocId;
            am.ARAccountID = this.dataLedgerItems[0].ARAccountID;
            am.DoctorName = this.dataLedgerItems[0].DoctorName;
            am.amount = 0;
            am.isSelected = false;
            this.PaymentAmountForDoctors.push(am);

            this.dataLedgerItems.forEach(ledgerItem => {
                if (this.isPayable(ledgerItem) && ledgerItem.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void) {
                    let d = this.PaymentAmountForDoctors.find(f => f.DoctorARLocId == ledgerItem.DoctorARLocId);
                    if (d === undefined) {
                        const a = {} as PaymentAmountForDoctorModel;
                        a.DoctorARLocId = ledgerItem.DoctorARLocId;
                        a.ARAccountID = ledgerItem.ARAccountID;
                        a.DoctorName = ledgerItem.DoctorName;
                        a.amount = 0;

                        a.isSelected = false;
                        this.PaymentAmountForDoctors.push(a);
                        d = this.PaymentAmountForDoctors.find(f => f.DoctorARLocId == ledgerItem.DoctorARLocId);
                    }
                    d.amount += this.returnAmountDue(ledgerItem);
                    if (ledgerItem.DoctorName !== '') {
                        d.DoctorName = ledgerItem.DoctorName;
                    }
                }
            });
            // Remove Doctors with no AR Account
            this.PaymentAmountForDoctors = this.PaymentAmountForDoctors.filter(doctor => doctor.DoctorARLocId !== null);

            // Filter out inactive doctors who have 0 amount due
            this.PaymentAmountForDoctors = this.PaymentAmountForDoctors.filter(doctor => {
                if (doctor.amount === 0) {
                    const arAccount = this.arAccounts.find(account => account.DoctorARLocId === doctor.DoctorARLocId);
                    return arAccount?.isActiveDoctor !== false;
                }
                return true;
            });
        }
        else {
            // if no ledger items to charge

            // get list of doctors
            this.PaymentAmountForDoctors = [];


            this.arService.getDoctorsARLocByLOCID(this.globals.LOCID).subscribe(res => {

                for (const element of res) {
                    const a = {} as PaymentAmountForDoctorModel;
                    a.DoctorARLocId = element.DoctorARLocId;
                    a.ARAccountID = element.ARAccountID;
                    a.DoctorName = element.DoctorName;
                    a.amount = 0;
                    //
                    a.isSelected = false;
                    this.PaymentAmountForDoctors.push(a);
                }
                // force change detection
                this.safeDetectChanges();
            });
        }

        return ConversionUtilities.roundDecimal(amountDue);
    }

    trimName(name: string) {
        if (name && name.length > 20) {
            return name.slice(0, 20);
        }
        return name;
    }

    init() {
        this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
        const locid = localStorage.getItem('LOCID');

        const promises = [
            firstValueFrom(this.paymentMethodConfigService.getPaymentMethodList(locid)),
            this.getAllDoctorARLocations(),
            this.getPaymentProcessorDevicesByWorkstation(this.currentWorkStationID, locid),
            this.getPaymentProcessorList(locid),
            this.getAllARAccounts()
        ];

        this.isLoading = true;
        Promise.all(promises).then((results: any[]) => {

            this.paymentMethods = results[0];
            this.arAccounts = results[1];
            this.paymentDevices = results[2];
            this.paymentProcessors = results[3];
            this.selectedPaymentType = this.paymentTypes[0];
            this.arAccountsAll = results[4];


            // set payment amount default
            this.paymentAmount = this.returnAmountDueAll();

            if (this.PaymentAmountForDoctors.length === 1) {
                this.PaymentAmountForDoctors[0].isSelected = true;
                this.depositARAccountID = this.PaymentAmountForDoctors[0].ARAccountID;
                this.selectedDoctorARLocId = this.PaymentAmountForDoctors[0].DoctorARLocId;
                this.setPaymentProcessor(this.PaymentAmountForDoctors[0].DoctorARLocId);
                this.startPayment(null);
            }

            if (this.data.dataARPaymentAudit) {
                // load window for existing payment
                this.paymentAmount = this.data.dataARPaymentAudit.PaymentAmount;
                this.approvedPaymentAmount = this.data.dataARPaymentAudit.ApprovedPaymentAmount;
                this.currentTransactionSetupID = this.data.dataARPaymentAudit.PaymentTransactionId;
                this.paymentAmountNotDistributed = this.data.dataARPaymentAudit.ApprovedPaymentAmount;
                this.datePostPayment = this.data.dataARPaymentAudit.PaymentTransactionDate;
                this.paymentDescription = this.data.dataARPaymentAudit.Description;

                const initPayment = new DataARPaymentModel();
                initPayment.PaymetnID = this.data.dataARPaymentAudit.PaymetnID;
                this.currentARPayment.set(initPayment);

                const payType = this.paymentTypes.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementTypeID);
                if (payType.length) {
                    this.selectedPaymentType = payType[0];
                }

                const payEType = this.paymentESources.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementETypeID);
                if (payEType.length) {
                    this.selectedEPaymentType = payEType[0];
                }

                const payCCType = this.paymentCCSources.filter(a => a.ValidValueItemId === this.data.dataARPaymentAudit.enumARPayementETypeID);
                if (payCCType.length) {
                    this.selectedCCPaymentType = payCCType[0];
                }

                const contact = this.contactList.filter(a => a.ContactId === this.data.dataARPaymentAudit.PayamentFromContactID);
                if (contact.length) {
                    this.selectedContact = contact[0];
                }

                // disable top half of screen
                //this.applyPayment = true;

                // filter by debit
            }

            this.isLoading = false;
            if (!this.destroyed) { this.safeDetectChanges(); }
        }, err => {
            this.createMessage('Something went wrong', 'Error');
            this.isLoading = false;
            if (!this.destroyed) { this.safeDetectChanges(); }
        });

    }

    // Handle selection and deselection of rows model data
    onRowSelected(event: TdoTableSelectionEvent) {
        const ledgerModel = this.dataLedgerItems.find(p => p === event.model);
        if (ledgerModel) {
            ledgerModel.DATA_SELECTED = event.isSelected;
        }
        //this.startPayment(event);
    }

    hasSelectedItems() {
        if (this.dataLedgerItems.filter(item => item.DATA_SELECTED).length) {
            return true;
        }
        else {
            return false;
        }
    }

    sortEnum(enumList: any[]) {
        return enumList.sort((a, b) => a.ItemOrder - b.ItemOrder);
    }

    getEnumValidValueItemsByValidValueName(ValidValueName: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getEnumValidValueItemsByValidValueName(ValidValueName)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    close(payload) {
        this.dialogRef.close(payload);
    }

    convertUTCDateToLocalDateFromString(dateString) {
        if (!dateString) {
            return null;
        }

        const date = new Date(dateString);
        return this.convertUTCDateToLocalDate(date);
    }

    convertUTCDateToLocalDate(date) {
        return new Date(
            Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                date.getHours(),
                date.getMinutes(),
                date.getSeconds()
            )
        );
    }

    clearSelectedItems() {
        this.dataLedgerItems.forEach(item => { item.DATA_SELECTED = false; });
    }

    buildPDFFromPayment(payment, isPaid = true) {
        const promise = new Promise((resolve, reject) => {
            const dialogRef = this.dialog.open(ArPaymentInvoiceGeneratorComponent, {
                width: '90%',
                height: '90%',
                data: {
                    isPaid,
                    paymentId: payment.PaymetnID,
                    dataPatient: this.dataPatient,
                    patientMode: false,
                    LOCID: localStorage.getItem('LOCID'),
                }
            });
            dialogRef.afterClosed().subscribe({
                next: result => resolve(result),
                error: () => resolve(false)
            });

        });
        return promise;
    }

    saveCurrencyField2(event, fieldName, ledgerID) {
        const inputValue = event.target.value;
        this.dataLedgerItems.forEach(ledgerItem => {
            if (ledgerItem.LedgerID.toUpperCase() === ledgerID.toUpperCase()) {
                const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
                if (num > ledgerItem.AmountDuePatient) {
                    this.createMessage('Amount entered is more than amount owed', 'Error');
                    return ledgerItem.AmountDuePatient;
                }
                else {
                    return num;
                }
            }
        });
    }

    saveCurrencyField(event, fieldName, ledgerID) {
        const inputValue = event.target.value;

        switch (fieldName) {
            case 'paymentAmount': {
                this.paymentAmount = Number(inputValue.replace(/[^0-9.-]+/g, ''));
                // force change detection
                this.safeDetectChanges();

                // per alyson - jira 828
                // should be able to make payment of any amount
                // if (this.paymentAmount > this.returnAmountDueAll()) {
                //   this.createMessage('Amount entered is more than amount owed', 'Error');
                //   this.paymentAmount = this.returnAmountDueAll();
                // }

                // more change detection
                // this.changeDet.markForCheck();
                break;
            }
            case 'ApplyPayment': {
                this.dataLedgerItems.forEach(ledgerItem => {
                    if (ledgerItem.LedgerID.toUpperCase() === ledgerID.toUpperCase()) {
                        const num = ConversionUtilities.roundDecimal(Number(inputValue.replace(/[^0-9.-]+/g, '')));
                        const numAmountDue = ConversionUtilities.roundDecimal(Number(ledgerItem.AmountDuePatient));
                        const prevValue = ConversionUtilities.roundDecimal(ledgerItem.ApplyPayment);
                        ledgerItem.ApplyPayment = num;

                        // given change, get new amount not/distributed
                        let amountDistributed = 0;
                        //let amountNotDistributed = 0;
                        this.dataLedgerItems.forEach(li => {
                            if (this.isPayable(li)) {
                                amountDistributed += ConversionUtilities.roundDecimal(li.ApplyPayment);
                            }
                        });
                        //amountNotDistributed = this.paymentAmount - amountDistributed;
                        amountDistributed = ConversionUtilities.roundDecimal(amountDistributed);
                        // force change detection
                        this.safeDetectChanges();

                        if (amountDistributed > this.paymentAmount) {
                            ledgerItem.ApplyPayment = prevValue;
                            this.createMessage('Amount entered is more than amount remaining', 'Error');
                        }
                        else if (num > ledgerItem.AmountDuePatient) {
                            ledgerItem.ApplyPayment = numAmountDue;
                            this.createMessage('Amount entered is more than amount owed', 'Error');
                        }
                        else {
                            ledgerItem.ApplyPayment = num;
                        }

                        // update tdo table model
                        this.tdoTable.dataSource = this.dataLedgerItems;
                        this.tdoTable.updateData();
                    }
                });
                break;
            }
        }
    }

    createPaymentForLedgerItem(paymentItem: any) {
        const promise = new Promise((resolve, reject) => {
            this.arService.createPaymentForLedgerItem(paymentItem)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    submitPayment(event) {
        const isValPayToken = this.checkValPayToken() && this.selectedToken?.Description !== 'Process CC only';
        const isTokenConsent = event === 'tokenConsent';
        const isAddNewToken = this.selectedToken?.Description === 'Add New Token';
        if (!isTokenConsent && isValPayToken && !this.selectedToken) {
            this.createMessage('Please select a payment token', 'Warning');
            return;
        }
        else if (!isTokenConsent && isValPayToken && isAddNewToken) {
            this.OpenCardPaymentConsent();
            return;
        }
        else if (!isTokenConsent && (!isValPayToken && (isAddNewToken || this.initializeToken))) {
            this.OpenCardPaymentConsent();
            return;
        }
        else if (!isTokenConsent && (isValPayToken && !isAddNewToken && this.selectedToken)) {
            this.chargeValPayToken(this.selectedToken);
            return;
        }
        else if ((!isValPayToken && !this.initializeToken) || isTokenConsent) {
            if (this.selectedLedgerItem
                && this.selectedLedgerItem.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypeInsurance
                && ConversionUtilities.roundDecimal(this.paymentAmountNotDistributed) > 0) {
                this.openInsuranceCreditRemainderConfirm(this.selectedLedgerItem, () => this.proceedWithPaymentSave());
                return;
            }

            this.proceedWithPaymentSave();
        }
    }

    private proceedWithPaymentSave(): void {
        // prevent double click
        if (this.submitPaymentInSuccess) {
            return;
        }
        this.submitPaymentInSuccess = true;
        this.isPaymentProcessing.set(true);
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
                //this.isPaymentProcessing.set(false);
                if (newPayment) {

                    // cfgARPayment record created
                    // record new payment
                    this.currentARPayment.set(newPayment);

                    // if electronic
                    if (newPayment.enumARPayementTypeID === EnumARPaymentType.CreditCard) {
                        newPayment.PaymentProcessorId = payDr.PaymentProcessorId;
                        this.openCardPaymentComponentNew(newPayment)
                            .then((result: ITDOPaymentTransactionResult) => {
                                this.isPaymentProcessing.set(false);
                                if (result?.success) {

                                    if (this.saveCCInfo === 1) {
                                        let saveInfo = `${this.dataPatient.PatientId}|${newPayment.PaymetnID}|${newPayment.PaymentProcessorId}`;
                                        saveInfo += this.verbalConsentInfo;
                                        this.saveCardPaymentInfo(saveInfo);
                                        this.saveCCInfo = 0;
                                    }
                                    // reset payments
                                    //this.resetApplyPaymentAmounts();
                                    // auto apply payment
                                    //this.autoApplyRemaining();    
                                    this.savePaymentDistributionClicked();
                                }
                                else {
                                    this.submitPaymentInSuccess = false;
                                    this.isPaymentProcessing.set(false);
                                    this.safeDetectChanges();
                                }
                            }, err => {
                                this.submitPaymentInSuccess = false;
                                this.isPaymentProcessing.set(false);
                                this.createMessage('Something went wrong', 'Error');
                                console.error(err);
                            });
                    }
                    else {
                        // not cc integrated
                        // create payment ledger item
                        this.createLedgerItemForPayment().then((success: any) => {
                            if (success) {
                                this.submitPaymentInSuccess = false;
                                this.isPaymentProcessing.set(false);
                                this.savePaymentDistributionClicked();
                            }
                        }, err => {
                            this.submitPaymentInSuccess = false;
                            this.isPaymentProcessing.set(false);
                            console.error(err);
                        });
                    }
                }
            }, err => {

                this.submitPaymentInSuccess = false;
                this.isPaymentProcessing.set(false);
                console.error(err);
            });
    }

    onAmountChanged(event, index: number) {
        const payDr = this.PaymentAmountForDoctors.at(index);
        payDr.amount = ConversionUtilities.roundDecimal(Number(event.target.value.replace('$', '').replace(',', '')));
        this.startPayment(event);
    }

    startPayment(event) {
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);

        // only do if not a credit
        if (!this.selectedLedgerItem) {
            if (payDr === undefined || payDr.amount === 0) {
                this.submitPaymentInSuccess = false;
                this.createMessage('Please enter a payment amount greater than zero.', 'Warning');
                return;
            }
            this.paymentAmount = payDr.amount;
        }
        // setup to distribute payment
        this.approvedPaymentAmount = this.paymentAmount;
        this.paymentAmountNotDistributed = this.paymentAmount;
        // disable top half of screen
        //this.applyPayment = true;
        // reset payments
        this.resetApplyPaymentAmounts();
        // auto apply payment
        this.autoApplyRemaining();

    }


    chargeValPayToken(payToken: DataArPaymentToken) {
        // charge here and then make sure it gets into ledger
        this.isPaymentProcessing.set(true);
        // zoli for valpay
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        this.paymentAmount = payDr.amount;

        // Saved credit cards are surcharged at the charging location's rate. The patient isn't at a terminal or web form,
        // so staff confirm they told the patient before the payment record is created and the card is charged.
        this.arService.getTokenSurchargeQuote(payToken.CCPaymentTokenID, payDr.PaymentProcessorId, this.paymentAmount).subscribe({
            next: (quote) => {
                if (!quote.SurchargeApplies) {
                    this.chargeSavedCard(payToken, payDr.PaymentProcessorId, 0);
                    return;
                }
                const surcharge = this.currencyPipe.transform(quote.SurchargeAmount);
                const total = this.currencyPipe.transform(quote.TotalAmount);
                this.dialog.open(ConfirmComponent, {
                    data: {
                        title: 'Credit Card Surcharge',
                        message: `This saved card is a credit card, so a ${quote.SurchargeRate}% surcharge of <b>${surcharge}</b> will be added.`
                            + `<br/>Total charged to the card: <b>${total}</b>.`
                            + `<br/><br/>Has the patient been told about this surcharge?`,
                        isShowNo: true,
                        isShowCancel: false,
                        okText: `Yes, charge ${total}`,
                        noText: 'No, don\'t charge'
                    }
                }).afterClosed().subscribe((confirmed) => {
                    if (confirmed === true) {
                        this.chargeSavedCard(payToken, payDr.PaymentProcessorId, quote.SurchargeAmount);
                    } else {
                        this.isPaymentProcessing.set(false);
                    }
                });
            },
            error: (err) => {
                this.createMessage(typeof err?.error === 'string' ? err.error : 'Unable to check the surcharge for this card.', 'Error');
                this.isPaymentProcessing.set(false);
                console.error(err);
            }
        });
    }

    private chargeSavedCard(payToken: DataArPaymentToken, paymentProcessorId: string, acknowledgedSurchargeAmount: number) {
        this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {

            if (newPayment) {
                // cfgARPayment record created
                // record new payment
                this.currentARPayment.set(newPayment);
                newPayment.PaymentProcessorId = paymentProcessorId;

                const enterpriseId = localStorage.getItem('TDOEnterpriseId');
                const transactionIdentifier = enterpriseId.concat('-', newPayment.PaymetnID);

                this.arService.processValpayTokenPayment(payToken.CCPaymentTokenID, paymentProcessorId, transactionIdentifier, acknowledgedSurchargeAmount)
                    .subscribe({
                        next: (result: CreditCardTokenPaymentResponse) => {
                            if (result?.success) {
                                this.savePaymentDistributionClicked();
                                this.isPaymentProcessing.set(false);
                            }
                        },
                        error: (err) => {
                            // 400 is our own message (e.g. the surcharge changed); anything else is unexpected.
                            this.createMessage(typeof err?.error === 'string' ? err.error : 'Something went wrong', 'Error');
                            this.isPaymentProcessing.set(false);
                            console.error(err);
                        }
                    });
            }
        }, err => {
            this.isPaymentProcessing.set(false);
            console.error(err);
        });
    }

    checkValPayToken() {
        return this.paymentTokens.length > 1 && this.selectedPaymentMethod 
        && this.selectedPaymentMethod.enumARPayementTypeID === EnumARPaymentType.CreditCard;    
    }

    returnPaymentAmountFromString(paymentString) {
        let numbersOnly = paymentString;

        if (typeof numbersOnly !== 'string') {
            numbersOnly = '0';
        }

        const patt = /[^(\d+)\.(\d+)]/g;
        numbersOnly = numbersOnly.replace(patt, '');

        const parsedPaymentAmount = ConversionUtilities.roundDecimal(parseFloat(numbersOnly));
        return parsedPaymentAmount;
    }

    checkIfTotalIsValid(): boolean {
        return Number(this.paymentAmount) > 0;
    }

    checkIfPaymentAccountSelected() {
        if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard && this.currentPaymentProcessorId === '')
            return false;
        if ((this.selectedPaymentMethod && this.depositARAccountID) || this.selectedLedgerItem)
            return true;
        return false;
    }

    createMessage(message, type) {
        this.uiService.displayMessage(type, message);
    }

    setPaymentMethod() {
        this.saveButtonCaption = 'Start Payment';
        // always set the checkbox for initializing reccurence payment to false.
        this.initializeToken = false;
        this.selectedToken = null;
        this.DocPaymentProcessors = [];

        if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard) {
            this.dateReceivedMin = new Date();
            this.saveButtonCaption = 'Charge';
            this.isDisabledReceivedDate = true;

            if (this.dateReceivedPayment < this.dateReceivedMin) {
                this.dateReceivedPayment = this.dateReceivedMin;
            }
            // load  dataDoctorARPaymentProcessor for DoctorARLocId
            const drPayment = this.PaymentAmountForDoctors.find(f => f.isSelected === true);
            if (!drPayment) {
                this.createMessage('Please select a Doctor.', 'Error');
                return;
            }

            const drarlocid = drPayment?.DoctorARLocId;
            if (!drarlocid) {
                this.createMessage('Selected Doctor doesn\'t have valid AR Location.', 'Error');
                return;
            }
            this.setPaymentProcessor(drarlocid);
        }
        else {
            this.isDisabledReceivedDate = false;
            this.dateReceivedMin = null;
            this.depositARAccountID = this.selectedPaymentMethod.ARAccountID;
            this.saveButtonCaption = 'Start Payment';
        }
    }

    setPaymentProcessor(drarlocid: string) {
        this.ppService.getPaymentProcessorARLocList(drarlocid).subscribe((results) => {
            this.DocPaymentProcessors = results;
            if (this.DocPaymentProcessors.length > 0) {
                this.currentPaymentProcessorId = this.DocPaymentProcessors[0].PaymentProcessorId;
                this.setDocPaymentProcessor(this.currentPaymentProcessorId);
            }
            else {
                this.currentPaymentProcessorId = '';
                if (this.selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard && this.currentPaymentProcessorId === '')
                    this.createMessage('Doctor doesn\'t have a valid Payment Processor.', 'Error');

            }
            if (!this.destroyed) { this.safeDetectChanges(); }
        });
    }

    cancelClicked() {
        if (this.approvedPaymentAmount && this.paymentAmountNotDistributed > 0 && this.applyPayment) {
            // payments not all distributed
            const dialogRef = this.dialog.open(ArPaymentCancelComponent, {
                width: '650px',
                height: '250px',
                data: {
                    paymentAmount: this.approvedPaymentAmount,
                    arPaymentID: this.currentARPayment().PaymetnID
                }
            });
            dialogRef.afterClosed().subscribe({
                next: result => {
                    if (result) {
                        this.dialogRef.close(result);
                    }
                },
                error: () => { }
            });
        }
        else {
            // close window
            this.dialogRef.close();
        }
    }

    getPaymentProcessorDevicesByWorkstation(WorkstationID: string, LOCID: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentProcessorDevicesByWorkstation(WorkstationID, LOCID)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    getPaymentProcessorList(LOCID: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentProcessorList(LOCID)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    getAllDoctorARLocations() {
        const promise = new Promise((resolve, reject) => {
            this.arService.getAllDoctorARLocations()
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    getAllARAccounts() {
        const promise = new Promise((resolve, reject) => {
            this.arService.getAllARAccounts()
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    returnARAccountName(DoctorARLocId: string) {
        let ARAccountName: string = '';
        this.arAccounts.forEach(a => {
            if (a.DoctorARLocId === DoctorARLocId) {
                ARAccountName = a.AccountName;
            }
        });

        return ARAccountName;
    }

    returnARAccountNameById(ARAccountID: string) {
        let ARAccountName: string = '';
        this.arAccountsAll.forEach(a => {
            if (a.ARAccountID === ARAccountID) {
                ARAccountName = a.AccountName;
            }
        });
        return ARAccountName;
    }

    async returnValidPaymentTokens() {
        // make call here to check on payment tokens for patient
        const promise = new Promise((resolve, reject) => {
            this.arService.getPaymentTokenForPatient(this.dataPatient.PatientId)
                .subscribe({ next: resolve, error: reject });
        });
        await promise.then((result: DataArPaymentToken[]) => this.paymentTokens = result);
        const addNew = new DataArPaymentToken();
        addNew.Description = 'Add New Token';
        this.paymentTokens.push(addNew);
        const processCC = new DataArPaymentToken();
        processCC.Description = 'Process CC only';
        this.paymentTokens.push(processCC);
    }

    updateEPaymentTypes() {
        this.paymentESources = [];
        if (this.selectedPaymentType.ValidValueItemId === EnumARPaymentType.CreditCard) {
            // show paymentEtypes for electronic - debit, credit
            this.paymentESourcesMaster.forEach(a => {
                if (a.ValidValueItemId === this.enumPaymentETypeCreditCard
                    || a.ValidValueItemId === this.enumPaymentETypeDebitCard) {
                    this.paymentESources.push(a);
                }
            });
        }
        else if (this.selectedPaymentType.ValidValueItemId === EnumARPaymentType.CreditCardOffline) {
            // show paymentEtypes for electronic - debit, credit
            this.paymentESourcesMaster.forEach(a => {
                if (a.ValidValueItemId === this.enumPaymentETypeCreditCard
                    || a.ValidValueItemId === this.enumPaymentETypeDebitCard
                    || a.ValidValueItemId === this.enumPaymentETypeCareCredit
                    || a.ValidValueItemId === this.enumPaymentETypeECheck) {
                    this.paymentESources.push(a);
                }
            });
        }
    }

    clearDistributions() {
        // reset payment distributions
        this.resetApplyPaymentAmounts();
        this.setPaymentAmountDistributionRemaining();
    }

    autoApplyDistributions() {
        this.clearDistributions();
        this.autoApplyRemaining();
    }

    openCardPaymentComponentNew(payment: DataARPaymentModel) {

        const promise = new Promise((resolve, reject) => {

            const LOCID = localStorage.getItem('LOCID');
            const dialogRef = this.dialog.open(ArCardPaymentComponent, {
                width: '650px',
                height: '760px',
                maxHeight: '95vh',
                disableClose: true,
                panelClass: 'dialog',
                data: {
                    paymentAmount: payment.PaymentAmount,
                    LOCID,
                    arPayment: payment,
                    paymentFrom: this.selectedContact.FirstName + ' ' + this.selectedContact.LastName,
                    accountDescription: this.returnARAccountNameById(this.depositARAccountID),
                    paymentProcessorID: payment.PaymentProcessorId,
                    savePaymentInfo: this.saveCCInfo
                }
            });
            dialogRef.afterClosed().subscribe({
                next: result => resolve(result),
                error: () => { }
            });
        });
        return promise;
    }

    async OpenCardPaymentConsent() {
        if (this.isOpeningCardConsent) {
            return;
        }
        this.saveCCInfo = 1;
        const payDr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        this.paymentAmount = payDr.amount; // check if this is zero otherwise throw error up a screen
        if (this.paymentAmount <= 0) {
            this.createMessage('Selected Payment Amount is $0.00', 'Error');
            return;
        }
        this.isOpeningCardConsent = true;

        // Saved credit cards are surcharged when charged later, so the consent asks staff to confirm the patient knows.
        let surchargeRate = 0;
        const processor = this.DocPaymentProcessors?.find(p => p.PaymentProcessorId === payDr.PaymentProcessorId);
        try {
            const surcharge = await firstValueFrom(this.ppService.getLocationSurcharge(processor?.LOCID ?? Number(localStorage.getItem('LOCID'))));
            surchargeRate = surcharge?.SurchargeEnabled ? surcharge.SurchargeRate : 0;
        } catch (e) {
            console.error('Unable to load the location surcharge for the card consent', e);
        }

        const promise = new Promise((resolve, reject) => {
            const dialogRef = this.dialog.open(ArPaymentTokenConsentComponent, {

                disableClose: true,
                panelClass: 'dialog',
                data: {
                    amount: this.paymentAmount,
                    patient: this.dataPatient,
                    patientId: this.dataPatient.PatientId,
                    surchargeRate
                }
            });
            dialogRef.afterClosed().subscribe({
                next: result => {
                    this.isOpeningCardConsent = false;
                    if (result && Array.isArray(result)) {
                        const expirationDate = result[0];
                        this.verbalConsentInfo = `|${expirationDate}`;
                        if (result.length === 2) {
                            const contactId = result[1];
                            this.verbalConsentInfo += `|${contactId}`;
                        }
                        this.submitPayment('tokenConsent');
                        resolve(result);
                    } else {
                        this.safeDetectChanges();
                        resolve(result);
                    }
                },
                error: () => {
                    this.isOpeningCardConsent = false;
                    this.safeDetectChanges();
                }
            });

        });
        return promise;
    }

    saveCardPaymentInfo(tokenInfo: string) {
        const promise = new Promise((resolve, reject) => {
            this.arService.saveCCPaymentTokenInfo(tokenInfo)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }


    createPaymentDistribution(ledgerID: string) {
        const promise = new Promise((resolve, reject) => {

            // create credit for approved payment amount
            const paymentDist = new DataARPaymentDistribsModel();
            paymentDist.Amount = this.paymentAmountNotDistributed;
            paymentDist.PaymetnID = this.data.arPaymentID;
            paymentDist.LedgerID = ledgerID;

            this.arService.CreatePaymentDistribution(paymentDist)
                .subscribe({ next: resolve, error: reject });
        });
        return promise;
    }

    async createCreditForUndistributedPayment() {

        try {
            // credit ledger item
            const ledgerItemCredit = new DataARLedgerModel();
            ledgerItemCredit.LOCID = parseInt(localStorage.getItem('LOCID'));
            ledgerItemCredit.PatientId = this.globals.currentPatientId;
            ledgerItemCredit.PostDate = new Date();
            ledgerItemCredit.Amount = this.paymentAmountNotDistributed;
            ledgerItemCredit.Description = 'Undistributed payment credit - Administrative';
            ledgerItemCredit.Reference = 'Overpay Conversion';
            const remainderOriginTypeID = this.creditRemainderOriginTypeID
                ?? this.selectedLedgerItem?.enumARLedgerItemOriginTypeID
                ?? this.enumLedgerItemOriginTypePatient;
            ledgerItemCredit.enumARLedgerItemTypeID = remainderOriginTypeID === this.enumLedgerItemOriginTypeInsurance
                ? LEDGER_ITEM_TYPE.CreditAdjustmentInsurance
                : LEDGER_ITEM_TYPE.CreditAdjustment;
            ledgerItemCredit.enumARLedgerItemOriginTypeID = remainderOriginTypeID;
            ledgerItemCredit.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
            ledgerItemCredit.PaymetnID = this.currentARPayment().PaymetnID;
            ledgerItemCredit.DoctorARLocId = this.selectedDoctorARLocId
                ?? (this.PaymentAmountForDoctors?.length === 1 ? this.PaymentAmountForDoctors[0].DoctorARLocId : null)
                ?? this.arAccounts?.find(a => a.ARAccountID === this.depositARAccountID)?.DoctorARLocId
                ?? null;

            await firstValueFrom(this.arService.saveLedgerItem(ledgerItemCredit));
            this.createMessage('Credit created for undistributed payment amount', 'Success');
            this.isPaymentProcessing.set(false);
            this.creditRemainderOriginTypeID = null;
            this.close(true);
        } catch (err) {
            console.error('err', err);
            this.createMessage('Credit not created', 'Error');
            this.isPaymentProcessing.set(false);
        }
    }

    openChooseLedgerItemWindow() {
        const dialogRef = this.dialog.open(ArLedgerItemSelectComponent, {
            panelClass: 'dialog',
            autoFocus: false,
            data: {
                dataLedgerItems: this.dataCreditLedgerItems,
                isShowCredits: true
            }
        });
        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result) {
                    this.creditRemainderOriginTypeID = null;
                    this.applySelectedCreditLedgerItem(result);

                    // set flag to show that we are applying a credit
                    // for now if this.selectedLedgerItem has a value then we are assuming that a credit is being used
                }
            },
            error: () => { }
        });
    }

    openInsuranceCreditRemainderConfirm(selectedCreditLedgerItem: DataARLedgerListModel, onConfirmed: () => void): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            data: {
                title: 'Please confirm ...',
                message: 'This credit exceeds the amount being paid. Keep the remainder as Insurance Credit, or transfer it to Patient Credit?',
                isShowNo: true,
                isShowCancel: false,
                noText: 'Keep as Insurance Credit',
                okText: 'Transfer to Patient Credit'
            }
        });
        dialogRef.afterClosed().subscribe({
            next: confirmResult => {
                if (confirmResult === true) {
                    this.creditRemainderOriginTypeID = this.enumLedgerItemOriginTypePatient;
                    onConfirmed();
                } else if (confirmResult === false) {
                    this.creditRemainderOriginTypeID = this.enumLedgerItemOriginTypeInsurance;
                    onConfirmed();
                }
            },
            error: () => { }
        });
    }

    applySelectedCreditLedgerItem(selectedCreditLedgerItem: DataARLedgerListModel): void {
        this.selectedLedgerItem = selectedCreditLedgerItem;
        this.paymentAmount = ConversionUtilities.roundDecimal(this.selectedLedgerItem.Amount);
        this.selectedPaymentMethod = null;
        this.depositARAccountID = null;
        this.startPayment(null);
    }

    PaymentAmountForDoctorSelection(charge: PaymentAmountForDoctorModel) {
        this.PaymentAmountForDoctors.forEach(d => {
            if (d.DoctorARLocId === charge.DoctorARLocId) {
                d.isSelected = charge.isSelected;
            }
            else {
                d.isSelected = false;
            }

            if (d.isSelected === true) {
                this.depositARAccountID = d.ARAccountID;
                this.selectedDoctorARLocId = d.DoctorARLocId;
                this.setPaymentProcessor(d.DoctorARLocId);
                this.startPayment(null);
            }
        });
    }

    setDocPaymentProcessor(paymentProcessorId: string) {
        this.currentPaymentProcessorId = paymentProcessorId;
        const dr = this.PaymentAmountForDoctors.find(f => f.isSelected);
        dr.PaymentProcessorId = paymentProcessorId;
    }

    async openPaymentReceipt() {
        this.isPrintingReceipt = true;
        const paymentPrintParameters = new PrintCCReceiptModel();
        paymentPrintParameters.PatientID = this.globals.currentPatientId;
        paymentPrintParameters.EnterpriseID = localStorage.getItem('TDOEnterpriseId');
        paymentPrintParameters.LOCID = this.globals.LOCID;
        paymentPrintParameters.TDOCID = localStorage.getItem('TDOCID');
        paymentPrintParameters.PaymentID = this.currentARPayment().PaymetnID;
        try {
            const documentID = await this.printService.printReport(ReportIDEnum.reportID_CreditCardReceiptReport, paymentPrintParameters).toPromise();
            this.printService.executePrint([documentID]);
            this.isPrintingReceipt = false;
        }
        catch (error) {
            this.createMessage('Error when trying to print Document.', 'error');
            this.isPrintingReceipt = false;
        }
    }
    IsChargeDisabled() {
        if (this.selectedLedgerItem) {
            const amountApplied = ConversionUtilities.roundDecimal(this.approvedPaymentAmount - this.paymentAmountNotDistributed, 2);
            return amountApplied <= 0;
        }
        return !this.checkIfTotalIsValid() || !this.checkIfPaymentAccountSelected()
            || this.approvedPaymentAmount <= 0 || this.approvedPaymentAmount < this.paymentAmount
            || !this.selectedPaymentMethod
            || (this.checkValPayToken() && !this.selectedToken)
            || this.isOpeningCardConsent;
    }

    private safeDetectChanges() {
        const viewRef = this.changeDet as any;
        if (!viewRef.destroyed) {
            this.changeDet.detectChanges();
        }
    }
}
